import { UpdateKeyValueRequest } from "@models/base/updateKeyValueRequest.model"

export class UpdatePericiaRequest extends UpdateKeyValueRequest{

  notificacionRealizada!: boolean;
  lugar!: string;
  activo!: boolean;
  fechaRealizada!: Date;
  fechaPropuesta!: Date;
  fechaFinalizada!: Date;
  idExpediente!: number;
  idEstadoPericia!: number;
  idTipoPericia!: number;
  urlReunion!: string;
  fechaCedulaPresentacion!: Date;
  fechaVencePresentacion!: Date;
  fechaAceptaCargo!: Date;
  fechaProponePericia!: Date;
  fechaRealizaPericia!: Date;
}
